import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { BorrowerStatus } from 'enums/curo/BorrowerStatus';
import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import LoaderStep from 'pages/CuroPages/ApplicationProcess/steps/LoaderStep';
import { runSnowflakeRefiScore, runSnowflakeRefiReloanScore } from 'thunks';

const ApplicationRefiScoreCheckStep = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const application = useSelector(getApplicationSelector);

  const runRefiCheck = async () => {
    if (
      [BorrowerStatus.Former, BorrowerStatus.Existing].includes(
        application?.variables[CuroApplicationVariables.BorrowerStatus] as BorrowerStatus,
      )
    ) {
      await dispatchWithUnwrap(runSnowflakeRefiReloanScore());
    }
    if (
      application?.variables[CuroApplicationVariables.BorrowerStatus] === BorrowerStatus.Existing
    ) {
      await dispatchWithUnwrap(runSnowflakeRefiScore());
    }
  };

  useEffect(() => {
    runRefiCheck();
  }, []);

  return <LoaderStep />;
};

export default ApplicationRefiScoreCheckStep;
